import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLazyResalePlansExportQuery } from '@/backoffice/redux/api/billing-backoffice/billing-backoffice-api';
import { SheetIcon } from '@/shared/assets/icons/sheet-icon';
import { ButtonWrapper } from '@/shared/components/ui/button/button-wrapper/button-wrapper';
import { FeatureCard } from '@/shared/components/ui/feature-card/feature-card';
import { useDownloadFile } from '@/shared/hooks/use-download-file/use-download-file';

export const PlansExport: React.FC = () => {
  const { t } = useTranslation();
  const [triggerExport] = useLazyResalePlansExportQuery();

  const requestDownloadUrl = async () => {
    const response = await triggerExport().unwrap();
    return response.resalePlansExport.url ?? '';
  };

  const { handleClick } = useDownloadFile({ requestDownloadUrl });

  return (
    <ButtonWrapper onClick={handleClick}>
      <FeatureCard
        icon={<SheetIcon />}
        title={t('backoffice:data_exports.plans.title')}
        description={t('backoffice:data_exports.plans.description')}
      />
    </ButtonWrapper>
  );
};
